import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = { class: "text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_form_field = _resolveComponent("bs5-form-field")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    as: "",
    "validation-schema": _ctx.schema
  }, {
    default: _withCtx(({ meta, handleSubmit }) => [
      _createVNode(_component_bs5_base_modal, {
        title: _ctx.$t('users.assignTitle'),
        visible: _ctx.visible,
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            novalidate: "",
            onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.assignDistributor)), ["prevent"])
          }, [
            (_ctx.distributors?.length > 0)
              ? (_openBlock(), _createBlock(_component_bs5_form_field, {
                  key: 0,
                  id: "assignDistributorSelect",
                  name: "distributor",
                  label: _ctx.$t('users.distributor'),
                  placeholder: _ctx.$t('users.chooseDistributor'),
                  options: _ctx.distributorOptions,
                  modelValue: _ctx.selectedDistributorId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDistributorId) = $event))
                }, null, 8, ["label", "placeholder", "options", "modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("users.distributor")), 1),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("users.noDistributorAvailable")), 1)
                ])),
            _cache[1] || (_cache[1] = _createElementVNode("button", {
              type: "submit",
              class: "d-none",
              tabindex: "-1",
              "aria-hidden": "true"
            }, null, -1))
          ], 40, _hoisted_1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
          _createVNode(_component_bs5_save_button, {
            loading: _ctx.saving,
            disabled: !meta.valid,
            onClick: ($event: any) => (handleSubmit($event, _ctx.assignDistributor))
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-diagram-3" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t("users.assign")), 1)
            ]),
            _: 2
          }, 1032, ["loading", "disabled", "onClick"])
        ]),
        _: 2
      }, 1032, ["title", "visible", "onClose"])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}